// Misma búsqueda que TrasladoController (searchQuery): ID exacto (o "CS<id>") y texto en los demás campos.
// La usan el filtro local de Centro de Control y las actualizaciones por WebSocket para que un traslado
// buscado por ID no desaparezca al confirmarlo o validarlo (2026-10-21)
const CAMPOS_TEXTO = [
  "nombre_paciente",
  "numero_documento_paciente",
  "preautorizacion",
  "autorizacion",
  "placa",
  "nombre_conductor",
  "origen_lugar",
  "destino_lugar",
];

const textoCampo = (valor) => {
  if (valor == null) return "";
  if (typeof valor === "object") {
    return String(valor.numero_autorizacion ?? valor.numero_preautorizacion ?? "");
  }
  return String(valor);
};

export const coincideBusquedaTraslado = (traslado, busqueda) => {
  const termino = String(busqueda ?? "").trim().toLowerCase();
  if (!termino) return true;

  const id = /^\d+$/.test(termino)
    ? termino
    : /^cs\s*\d+$/.test(termino)
    ? termino.replace(/^cs\s*/, "")
    : null;
  if (id !== null && String(traslado.id) === String(Number(id))) return true;

  return CAMPOS_TEXTO.some((campo) =>
    textoCampo(traslado[campo]).toLowerCase().includes(termino)
  );
};
